<template>
    <div>
        <van-nav-bar title="逾期日报" fixed/>

        <!-- 目标 -->
        <h2 class="line-title mp60 iconMenu" id="test3">
            <span>截止到{{date}}逾期日报</span>
        </h2>
        <div style="margin:10px">
            <canvas id="target" style="width: 100%;height: 200px"></canvas>
        </div>
        <canvas id="pie1" style="width: 100%;height: 200px; margin-bottom: 80px;margin-top: 20px"></canvas>
        <div style="margin-top: -30px">
            <van-grid direction="horizontal" column-num="4">
                <van-grid-item  text="逾期属性" />
                <van-grid-item  text="金额" />
                <van-grid-item  text="逾期率" />
                <van-grid-item  text="环比" />
                <template v-for="index in pieData1.length ">
                    <van-grid-item   :text="pieData1[index-1].overdueAttribute+''" />
                    <van-grid-item   :text="pieData1[index-1].overdueAmount+'万'" />
                    <van-grid-item   :text="pieData1[index-1].overdueRate+''" />
                    <van-grid-item   :text="pieData1[index-1].dayChange+''" />
                </template>
            </van-grid>
        </div>
    </div>
</template>

<script>
    import F2 from '@antv/f2/lib/index-all';
    import {getOverDueDayStatic } from '@/api/monitoring'
    import insertCss from 'insert-css';
    import moment from 'moment';

    insertCss(`
      canvas.guage {
        border-radius: 5px;
        background-color: #1890ff;
        background-image: linear-gradient(#246BFF, #2797FF);
      }
    `);
    const {
        Shape,
        G,
        Util,
        Global
    } = F2;
    const Vector2 = G.Vector2;

    export default {
        name: 'overdue',
        components: {},
        data: function () {
            return {
                year: moment().format('YYYY'),
                groupData: [],// 柱状图数据
                targetAmount: 0,// 目标
                scale: 0,// 逾期率
                totalPrincipalBalance:0,//贷款余额
                totalPrincipal:0,//逾期贷款余额
                /* 图表实例*/
                targetChart: null,
                pieData1: [],
                date:null,
                openId:'',
            }
        },
        methods: {
            init2() {
                // 设置独立的css
                const self = this
                const container = document.getElementById('target');
                container.className = 'guage';
                Shape.registerShape('interval', 'polar-tick', {
                    draw: function draw(cfg, container) {
                        const points = this.parsePoints(cfg.points);
                        const style = Util.mix({
                            stroke: cfg.color
                        }, Global.shape.interval, cfg.style);

                        let newPoints = points.slice(0);
                        if (this._coord.transposed) {
                            newPoints = [points[0], points[3], points[2], points[1]];
                        }

                        const center = cfg.center;
                        const x = center.x,
                            y = center.y;
                        const v = [1, 0];
                        const v0 = [newPoints[0].x - x, newPoints[0].y - y];
                        const v1 = [newPoints[1].x - x, newPoints[1].y - y];
                        const v2 = [newPoints[2].x - x, newPoints[2].y - y];

                        let startAngle = Vector2.angleTo(v, v1);
                        let endAngle = Vector2.angleTo(v, v2);
                        const r0 = Vector2.length(v0);
                        const r = Vector2.length(v1);

                        if (startAngle >= 1.5 * Math.PI) {
                            startAngle = startAngle - 2 * Math.PI;
                        }

                        if (endAngle >= 1.5 * Math.PI) {
                            endAngle = endAngle - 2 * Math.PI;
                        }

                        const lineWidth = r - r0;
                        const newRadius = r - lineWidth / 2;

                        return container.addShape('Arc', {
                            className: 'interval',
                            attrs: Util.mix({
                                x,
                                y,
                                startAngle,
                                endAngle,
                                r: newRadius,
                                lineWidth,
                                lineCap: 'round'
                            }, style)
                        });
                    }
                });
                const data = [{
                    const: 'a',
                    actual: self.scale,
                    expect: 100
                }];
                this.targetChart = new F2.Chart({
                    id: 'target',
                    padding: [0, 30, 60],
                    pixelRatio: window.devicePixelRatio
                });
                this.targetChart.source(data, {
                    actual: {
                        max: 100,
                        min: 0,
                        nice: false
                    }
                });
                this.targetChart.coord('polar', {
                    transposed: true,
                    innerRadius: 0.8,
                    startAngle: -Math.PI,
                    endAngle: 0
                });
                this.targetChart.axis(false);
                this.targetChart.interval()
                    .position('const*expect')
                    .shape('polar-tick')
                    .size(10)
                    .color('rgba(80, 143, 255, 0.95)')
                    .animate(false); // 背景条
                this.targetChart.interval()
                    .position('const*actual')
                    .shape('polar-tick')
                    .size(10)
                    .color('#fff')
                    .animate({
                        appear: {
                            duration: 1100,
                            easing: 'linear',
                            animation: function animation(shape, animateCfg) {
                                const startAngle = shape.attr('startAngle');
                                let endAngle = shape.attr('endAngle');
                                if (startAngle > endAngle) {
                                    // -Math.PI/2 到 0
                                    endAngle += Math.PI * 2;
                                }
                                shape.attr('endAngle', startAngle);
                                shape.animate().to(Util.mix({
                                    attrs: {
                                        endAngle
                                    }
                                }, animateCfg)).onUpdate(function (frame) {
                                    const textEl = document.querySelector('#text');
                                    if (textEl) textEl.innerHTML ='逾期率:'+parseFloat((frame * self.scale).toFixed(2)) + '%';
                                });
                            }
                        }
                    }); // 实际进度
                let amt = self.totalPrincipal
                this.targetChart.guide().html({
                    position: ['50%', '80%'],
                    html: `
                        <div style="width: 120px;color: #fff;white-space: nowrap;text-align:center;">
                          <p id="totalPrincipalText" style="font-size: 14px;margin-top:-40px"></p>
                          <p id="text" style="font-size: 14px;margin:0"></p>
                          <p id="totalPrincipalBalanceText" style="font-size: 13px;"></p>
                        </div>`
                });
                this.targetChart.render();
            },
            init3() {
                const chart = new F2.Chart({
                    id: 'pie1',
                    pixelRatio: window.devicePixelRatio
                });
                chart.source(this.pieData1);
                chart.coord('polar', {
                    transposed: true,
                    radius: 0.8,
                    innerRadius: 0.5
                });
                chart.axis(false);
                chart.legend(false);
                chart.tooltip(false);
                chart.guide()
                    .html({
                        position: [ '50%', '50%' ],
                        html: '<div style="text-align: center;width:150px;height: 50px;">\n      <p style="font-size: 12px;color: #999;margin: 0" id="title"></p>\n      <p style="font-size: 18px;color: #343434;margin: 0;font-weight: bold;" id="money"></p>\n      </div>'
                    });
                chart.interval()
                    .position('const*overdueAmount')
                    .adjust('stack')
                    .color('overdueAttribute', [ '#1890FF', '#13C2C2', '#2FC25B', '#FACC14' ]);
                chart.pieLabel({
                    sidePadding: 30,
                    activeShape: true,
                    label1: function label1(data) {
                        return {
                            text: '￥' + data.overdueAmount+'万/环比'+data.dayChange,
                            fill: '#343434',
                            fontWeight: 'bold'
                        };
                    },
                    label2: function label2(data) {
                        return {
                            text: data.overdueAttribute+'('+data.overdueRate+')',
                            fill: '#999'
                        };
                    },
                    onClick: function onClick(ev) {
                        const data = ev.data;
                        if (data) {
                          /*  $('#title').text(data.type);
                            $('#money').text(data.money);*/
                        }
                    }
                });
                chart.render();
            },
            handleScaleData () {
                getOverDueDayStatic({date:this.date,openId:this.openId}).then(res=>{
                    if (res.success) {

                        this.pieData1 = []
                        res.data.overdue.forEach(item=>{
                            this.pieData1.push({
                                const: 'const',
                                overdueAttribute: item.overdueAttribute,
                                overdueAmount: item.overdueAmount,
                                overdueRate:item.overdueRate,
                                dayChange:item.dayChange
                            })
                        })
                        this.scale = parseFloat(res.data.overDueRate)
                        this.totalPrincipalBalance=res.data.totalPrincipalBalance
                        this.totalPrincipal=res.data.totalPrincipal
                        this.init2()
                        const totalPrincipalText = document.querySelector('#totalPrincipalText')
                        if (totalPrincipalText) totalPrincipalText.innerHTML ='逾期总额:'+this.totalPrincipal+'万'
                        const totalPrincipalBalanceText = document.querySelector('#totalPrincipalBalanceText')
                        if (totalPrincipalBalanceText) totalPrincipalBalanceText.innerHTML ='在贷总额:'+this.totalPrincipalBalance+'万'
                    }
                })
            },
        },
        mounted() {
            const self = this
            self.date=self.$route.query.date
            self.openId=self.$route.query.openId
            if(self.date){
                self.handleScaleData()
                setTimeout(()=>{
                    self.init3()
                },1000)
            }


        }
    }
</script>

<style scoped>
    .layer1 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .layer1 .title {
        margin-top: 20px;
    }

    .layer1 .amt {
        font-weight: bold;
        font-size: 18px;
        margin-top: 4px;
    }

    .layer2 {
        display: flex;
        margin-top: 10px;
    }

    .layer2 .item {
        width: 33%;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 10px;
    }

    .layer2 .item .num {
        margin-top: 4px;
    }

    .link-right {
        border: solid #ccc;
        border-width: 0 1px 1px 0;
        display: inline-block;
    }

    .line-title {
        margin: 0;
        margin: 16px 6px 6px 16px;
        color: rgba(69, 90, 100, 0.6);
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
    }

    .mp60 {
        margin-top: 60px;
    }

    .iconMenu {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .year {
        font-weight: bold;
    }

    .iconContent {
        display: flex;
        align-items: center;
    }
</style>
